import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import './ExchangeWithholdings.scss';
import '../../Buy/BuyFlow/ExpandedFundList//MarketVolatilityNote.scss';
import { moduleActions } from '../../../redux/modules';
import {
  getExchangeFromUnit,
  getSingleExchangeFederalWithholdingDollars,
} from '../../../redux/modules/exchangeTransaction/exchangeTransaction.selectors';
import {
  IRA_WITHHOLDING_WARNING_MODAL,
  FEDERAL_INCOME_TAX_WARNING,
  STATE_TAX_DISCLOSURE_MODAL,
} from '../../../redux/modules/modals/modals.module';
import { FederalTaxPercent } from '../../../settings/settings';
import If from '../../Shared/If/If';
import PercentageInput from '../../Shared/PercentageInput/PercentageInput';
import { coalesce, fullStateName } from '../../../utils/utils';
import iconHelp from '../../../assets/images/icon_info.svg';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import {
  getMandatoryWithholdingStates,
  getNonMandatoryWithholdingStates,
  getWithholdingStateLookup,
} from 'src/redux/modules/stateWithholding/selectors';
import IraWithholdingWarning from '../../Sell/IraWithholdingWarning/IraWithholdingWarning';
import StateIncomeTaxDisclosure from '../../Sell/StateIncomeTaxDisclosure/StateIncomeTaxDisclosure';
import { getUserAddress } from 'src/redux/modules/user/PersonalInformation/personalInformation.selectors';
import { getAutoExchangeToSummaryFund } from 'src/redux/modules/exchangeTransaction/autoExchangeTransaction.selectors';
import { getExchangeIsTaxable } from 'src/redux/modules/exchangeTransaction/exchangeTransaction.selectors';
class ExchangeWithholdings extends Component {
  constructor(props) {
    super(props);
    this.idPrefix = this.props.inTest
      ? 1
      : Math.random().toString(36).substr(2);
    this.state = {
      editingExchangeFederal: false,
      editingExchangeFederalInError: false,
      editingExchangeFederalValue: FederalTaxPercent.DEFAULT,
    };
    this.cacheFederalEdits = this.cacheFederalEdits.bind(this);
    this.cancelFederalEdits = this.cancelFederalEdits.bind(this);
    this.saveFederalEdits = this.saveFederalEdits.bind(this);
    this.startEditingFederal = this.startEditingFederal.bind(this);
  }
  cacheFederalEdits(editingExchangeFederalValue) {
    const editingExchangeFederalNum = parseFloat(editingExchangeFederalValue);
    let editingExchangeFederalInError =
      editingExchangeFederalNum !== 0 &&
      editingExchangeFederalNum < FederalTaxPercent.MIN;
    this.setState({
      editingExchangeFederalValue,
      editingExchangeFederalInError,
    });
    const {
      actions: { updateExchangeFederalWithholding },
    } = this.props;

    if (editingExchangeFederalInError) {
      return; // button is disabled anyways, really shouldn't get here
    }
    updateExchangeFederalWithholding(
      parseFloat(editingExchangeFederalValue) >= 0,
      editingExchangeFederalValue
    );
    editingExchangeFederalInError =
      editingExchangeFederalNum !== 0 &&
      (editingExchangeFederalNum < FederalTaxPercent.MIN ||
        editingExchangeFederalNum > FederalTaxPercent.MAX);
    this.setState({
      editingExchangeFederalValue,
      editingExchangeFederalInError,
    });
    if (
      (editingExchangeFederalValue > 80 &&
        this.props.eligibleMandatoryStates?.some(
          (state) => state === this.props.userState
        )) ||
      this.props.showFederalIncomeTaxWarning
    ) {
      this.props.actions.openModal(FEDERAL_INCOME_TAX_WARNING);
    }
    this.setState({ editingExchangeFederal: false });
  }
  cancelFederalEdits() {
    this.setState({ editingExchangeFederal: false });
  }
  saveFederalEdits() {
    const {
      actions: { updateExchangeFederalWithholding },
    } = this.props;
    const { editingExchangeFederalValue, editingExchangeFederalInError } =
      this.state;

    if (editingExchangeFederalInError) {
      return; // button is disabled anyways, really shouldn't get here
    }
    updateExchangeFederalWithholding(
      parseFloat(editingExchangeFederalValue) !== 0,
      editingExchangeFederalValue
    );
    if (
      (editingExchangeFederalValue > 80 &&
        this.props.eligibleMandatoryStates?.some(
          (state) => state === this.props.userState
        )) ||
      this.props.showFederalIncomeTaxWarning
    ) {
      this.props.actions.openModal(FEDERAL_INCOME_TAX_WARNING);
    }
    this.setState({ editingExchangeFederal: false });
  }
  startEditingFederal() {
    const { exchangeFederalWithholdingPercent } = this.props;
    this.setState({
      editingExchangeFederal: true,
      editingExchangeFederalInError: false,
      editingExchangeFederalValue: coalesce(
        exchangeFederalWithholdingPercent,
        FederalTaxPercent.DEFAULT
      ).toString(),
    });
  }
  render() {
    const { idPrefix } = this;
    const {
      editingExchangeFederal,
      editingExchangeFederalInError,
      editingExchangeFederalValue,
    } = this.state;
    const {
      actions: { openModal },
      disableCheckbox = false,
      exchangeFederalWithholdingApplied,
      isSalesforceRep,
      customerWebViewEnabled,
      //userStateWithholdingRules: { mandatory, stateCode },
      hasRoth,
      WithholdingStateLookup,
      userState,
      exchangeIsTaxable,
      mandatoryWithholdingStates,
      nonMandatoryWithholdingStates,
      autoExchangeFromSummaryFund,
    } = this.props;
    const year = new Date().getFullYear();

    const mandatoryStates = userState?.filter((state) => {
      return mandatoryWithholdingStates?.includes(state);
    });

    let stateRules;
    if (mandatoryStates?.length > 0) {
      stateRules = WithholdingStateLookup?.[mandatoryStates[0]];
    } else {
      stateRules = WithholdingStateLookup?.[userState?.[0]];
    }
    return (
      <>
        <If test={!customerWebViewEnabled && isSalesforceRep}>
          <div className="market-volatility-note-box">
            <div className="market-volatility-note">
              <IraWithholdingWarning
                caller={null}
                closeIraWithholdingWarning={null}
                isSalesforceRepMessage={true}
                setInputFocus={null}
              />
            </div>
          </div>
        </If>
        <If test={!customerWebViewEnabled && isSalesforceRep}>
          <If
            test={
              !autoExchangeFromSummaryFund?.nonRetirementLike &&
              stateRules?.mandatory
            }
          >
            <div className={'market-volatility-note-box'}>
              <div className={'market-volatility-note'}>
                <StateIncomeTaxDisclosure
                  closeStateIncomeTaxDisclosure={null}
                  isSalesforceRepMessage={true}
                  mandatoryWithholdingStates={mandatoryWithholdingStates}
                  nonMandatoryWithholdingStates={nonMandatoryWithholdingStates}
                  stateWithholdingRules={{
                    ...stateRules?.mandatory,
                    ...stateRules?.stateCode,
                  }}
                  state={userState?.[0]}
                />
              </div>
            </div>
          </If>
        </If>

        <div
          className={`exchange-withholding-container ${
            disableCheckbox ? 'exchange-withholding-no-border' : ''
          }`}
        >
          <If test={!isSalesforceRep}>
            <div className="exchange-withholding-title">
              Income Tax Withholding Disclosure
            </div>
            <p className="exchange-withholding-info">
              You have the right to elect no federal income tax withholding.
            </p>
            <If test={stateRules?.mandatory && userState.length === 1}>
              <p className="exchange-withholding-info">
                Your address of record is in
                <span className="exchange-withholding-state-name">
                  {' '}
                  {fullStateName(stateRules?.stateCode)}{' '}
                </span>
                which is a state that defaults withholding. As a result,{' '}
                <span
                  className={
                    'exchange-withholding-federal-withholding-info hyper-link-text'
                  }
                  onClick={() =>
                    openModal(STATE_TAX_DISCLOSURE_MODAL, {
                      caller: 'tooltip',
                      state: userState[0],
                    })
                  }
                >
                  state income taxes
                </span>{' '}
                will be withheld from your distribution in accordance with the
                applicable state rules.
              </p>
            </If>
            <If test={stateRules?.mandatory && userState.length > 1}>
              <p className="exchange-withholding-info">
                There are multiple addresses associated with your
                investments, some of which are in a state that defaults
                withholding. As a result, state income taxes will be withheld
                from your distribution in accordance with the applicable state
                rules.
              </p>
            </If>
            {!exchangeIsTaxable && (
              <p className="exchange-withholding-info">
                You may be responsible for payment of estimated tax if you do
                not have enough income tax withheld and you may incur tax
                penalties if your withholding and estimated tax payments are not
                sufficient.
              </p>
            )}

            <p className="exchange-withholding-info exchange-withholding-important">
              If you are under age 59½, a 10% penalty tax may be assessed by the
              IRS for certain distributions from an IRA. This 10% penalty tax
              would be in addition to any other federal or state taxes due as a
              result of this IRA distribution, as applicable.
            </p>
          </If>
          <div
            className={`exchange-withholding-deduction-line ${
              editingExchangeFederal ? 'exchange-withholding-editing' : ''
            } ${
              !exchangeFederalWithholdingApplied
                ? 'exchange-withholding-decline'
                : ''
            }`}
          >
            <div
              htmlFor="federal-withholding-percent-input"
              className="exchange-withholding-deduction-sub-label exchange-withholding-editing-federal-label"
            >
              <span className="federal-withholding-header">
                Federal Tax Withholding
              </span>
              <a
                id={`${idPrefix}-retirement-federal-withholding-info`}
                className={`e2e-federal-withholding-info-link-exchange exchange-withholding-federal-withholding-info`}
                onClick={() =>
                  openModal(IRA_WITHHOLDING_WARNING_MODAL, {
                    userState: userState[0],
                    mandatoryWithholdingStates: mandatoryWithholdingStates,
                    isRoth: hasRoth,
                    showPageIraTable: true,
                    showRothNotes: true,
                  })
                }
              >
                <img
                  className="exchange-withholding-federal-withholding-image"
                  alt="help"
                  src={iconHelp}
                />
              </a>

              <div className="fed-withholding-input-text">
                <PercentageInput
                  ariaLabel={`Federal withholding percentage between ${FederalTaxPercent.MIN} and ${FederalTaxPercent.MAX}`}
                  autoFocus
                  inputMode={'numeral'}
                  containerClassName="exchange-withholding-percent-input-container"
                  defaultValue={editingExchangeFederalValue}
                  displayErrorMessage={false}
                  displayInline
                  size={6}
                  error={editingExchangeFederalInError}
                  id="federal-withholding-percent-input"
                  inputClassName="exchange-withholding-percent-input"
                  onChange={(value) => this.cacheFederalEdits(value)}
                  placeholder={FederalTaxPercent.MIN}
                  wrapperClassName="exchange-withholding-percent-input-wrapper"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]*/g, '');
                  }}
                />
                <span
                  className={`exchange-withholding-editing-federal-note ${
                    editingExchangeFederalInError
                      ? 'exchange-withholding-error'
                      : ''
                  }`}
                >
                  Edit this field if you would like a rate of withholding that
                  is different from the default withholding rate. See the
                  instructions on page 2 of the IRS{' '}
                  <a
                    href="https://www.irs.gov/pub/irs-pdf/fw4r.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Form W-4R{' '}
                  </a>{' '}
                  and the Marginal Rate Tables for additional information. Enter
                  the rate as a whole number (no decimals). The following link
                  will take you to the{' '}
                  <a
                    href="https://www.irs.gov/pub/irs-pdf/fw4r.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {year} Marginal Rate Tables
                  </a>
                  . You may use these tables to help you select the appropriate
                  withholding rate for this payment or distribution.
                  Instructions on how to best use them are included.
                </span>
              </div>
            </div>
          </div>
          <p
            className={`exchange-withholding-info exchange-withholding-declined ${
              exchangeFederalWithholdingApplied &&
              Number(editingExchangeFederalValue) !== 0
                ? 'exchange-withholding-applied'
                : ''
            }`}
          >
            Because you declined additional Federal tax withholding, you may be
            responsible for payment of estimated tax and may also incur
            penalties under the estimated tax rules should your estimated tax
            payments be insufficient.
          </p>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    exchangeTransaction: {
      exchangeFederalWithholdingApplied,
      exchangeFederalWithholdingPercent,
    },
  } = state;
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    userAddress: getUserAddress(state),
    exchangeFromUnit: getExchangeFromUnit(state),
    exchangeFederalWithholdingApplied,
    exchangeIsTaxable: getExchangeIsTaxable(state),
    exchangeFederalWithholdingDollars:
      getSingleExchangeFederalWithholdingDollars(state),
    eligibleMandatoryStates: getMandatoryWithholdingStates(state),
    nonMandatoryWithholdingStates: getNonMandatoryWithholdingStates(state),
    autoExchangeFromSummaryFund: getAutoExchangeToSummaryFund(state),
    exchangeFederalWithholdingPercent,
    WithholdingStateLookup: getWithholdingStateLookup(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ExchangeWithholdings
);
